import React, { useId } from 'react';
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg';
export const IconGoogleSheets = ({ width = 24, height = 24, border, }) => {
    const id = useId();
    return (<Svg width={width} height={height} viewBox="0 0 44 44" fill="none">
      <Rect width="44" height="44" rx="22" fill="white"/>
      {border ? (<Rect x="0.5" y="0.5" width="43" height="43" rx="21.5" stroke="#6E7191" strokeOpacity="0.05"/>) : null}
      <G clipPath={`url(#clip0_${id})`}>
        <Path d="M24.5 11L30 16.5L27.25 17L24.5 16.5L24 13.75L24.5 11Z" fill="#188038"/>
        <Path d="M24.5 16.5V11H15.5C14.6712 11 14 11.6712 14 12.5V31.5C14 32.3287 14.6712 33 15.5 33H28.5C29.3287 33 30 32.3287 30 31.5V16.5H24.5Z" fill="#34A853"/>
        <Path d="M17 19.5V26.75H27V19.5H17ZM21.375 25.5H18.25V23.75H21.375V25.5ZM21.375 22.5H18.25V20.75H21.375V22.5ZM25.75 25.5H22.625V23.75H25.75V25.5ZM25.75 22.5H22.625V20.75H25.75V22.5Z" fill="white"/>
      </G>
      <Defs>
        <ClipPath id={`clip0_${id}`}>
          <Rect width="16" height="22" fill="white" transform="translate(14 11)"/>
        </ClipPath>
      </Defs>
    </Svg>);
};
